import React from 'react';
import * as action from './../../../action/buildProduct';
import { connect } from 'react-redux'
import { withCookies } from 'react-cookie';
import { AccordionStatus } from './../../../constants/actionType';
import { updateSCcustomEvent,tempSCData, updateSCTags} from './../../../service/dtmTag';
import {invokeTouchCommerce} from './../../../service/aimsChat';
import PromoContent from './../../../constants/promoContent';
import { InHomeUtils } from './../../../util/inhomeUtils';
import {catchJSException} from './../../../service/logService';
import * as buildProductAction from './../../../action/buildProduct'
import { updateDetailValue,updateFlowName,updateVzdlSCCustomEvent } from '../../../service/change/vzdl';
import { Title } from '@vds/typography';
import DowncaretIcon from '@vds/icons/down-caret';
import UpcaretIcon from '@vds/icons/up-caret';
import WifiIcon from '@vds/icons/wifi-wireless';
import GiftIcon from '@vds/icons/gift';
import ServicesIcon from '@vds/icons/services';
import ComplianceIcon from '@vds/icons/compliance-document';
import { AccordionTitle,AccordionSubTitle } from '@vds/accordions';
import Phone from '@vds/icons/phone';
import Tv from '@vds/icons/tv';

class accordionTitleRskn extends React.PureComponent {
  handleKeyDown = (e, name, title, omniTitle) => {
    //keyboard accessibility for accordion using space bar and enter keys
    if (e.keyCode === 13 || e.keyCode === 32) {
      this.openAccordion(e, name, title, omniTitle);
    }
  };
  openAccordion = (e, name, title, omniTitle = "") => {
    try {
      if (InHomeUtils.isNotNull(name)) {
        invokeTouchCommerce(name);
        action.setAccordionStatus(name, this.props.dispatch, this.props.isAccordionOpen);
        if (!this.props.isAccordionOpen) {
          let val = this.props.isDoFlow ? "do accord" : "byob";
          tempSCData.pageName = val;
          if (name.indexOf("internet") > -1 || name.indexOf("datasub") > -1) {
            // val = val + "| internet"
            val = val + "| internet" + "| " + title;
          } else if (name.indexOf("tv") > -1) {
            val = val + "| tv" + "| " + title;
          } else if (name.indexOf("phone") > -1) {
            if (title === "Call more countries & destinations") {
              title = "call more countries";
            }
            val = val + "| phone" + "| " + title;
          } else if (name.indexOf("perks") > -1) {
            this.buildProductAction.fetchPerksMTM(
              dispatch,
              visitId,
              couponflowType,
              flowType
            );
            val = val + "| perks" + "| " + title;
          } else if (name.indexOf("streamingserv_acc") > -1) {
            val = val + "| stream services-devices";
          } else if (name.indexOf("streamingserv_plan") > -1) {
            val = val + "| stream services-devices| pick service";
          } else if (name.indexOf("streamingdevcnt_plan") > -1) {
            val = val + "| stream services-devices| add devices-nums";
          } else if (name.indexOf("contract") > -1) {
            val = val + "| contract";
          } else if (name.indexOf("internationalchannel") > -1) {
            val = val + "|  tv| add international channel";
          } else if (name.indexOf("flash") > -1) {
            val = val + "| internet| black friday ";
          } else if (name.indexOf("splOffer") > -1) {
            val = val + "| internet| select your int promo offer";
          } else if (name.indexOf("emergency_services") > -1) {
            val = val + "| phone| Emergency Services";
          }
          tempSCData.detailPageName = val; // for DOflows/Prepaid need to uodate these values later
          if (InHomeUtils.isNotNull(omniTitle) && omniTitle !== "") {
            let title = "";
            if (omniTitle === "Please select internet") {
              title = "Add Internet";
            } else if (omniTitle === "Please select router") {
              title = "Add router";
            } else if (omniTitle === "A special gift, on us") {
              title = "Choose your offer";
            }  else if (omniTitle === "TV Connections") {
              title = "Add settop box ";
            } else if (omniTitle === "Pick your recording service") {
              title = "Add recording service";
            } else if (omniTitle === "Please pick your Live TV option") {
              title = "Add Live TV";
            } else if (omniTitle === "Pick your voice option") {
              title = "Add phone";
            } else if (omniTitle === "Choose your perks") {
              title = "Perks";
            } else if (omniTitle.indexOf("Emergency services") > -1) {
              title = "Emergency Services";
            } else {
              title = omniTitle;
            }
            updateDetailValue(title)
          } else {
            let detailValue=""
            if (
              name.indexOf("internet") > -1 ||
              name.indexOf("tv") > -1 ||
              name.indexOf("phone") > -1 
            ) {
              detailValue =
                val.split("|") && val.split("|").length > 2
                  ? val.split("|")[2].trim()
                  : "";
            } else if (name.indexOf("flash") > -1) {
              detailValue = "internet - black friday";
            }else if (name.indexOf("splOffer") > -1) {
              detailValue = "Choose your offer";
            } else {
              detailValue = val.split("|")[1].trim();
            }
            updateDetailValue(detailValue)
          }

          if (this.props.flowType === "MV") {
            let flowName=""
            if (
              this.props.cust_opt === "NONSEAMLESS" &&
              this.props.isFCPflow &&
              !this.props.isFcpInProfile
            ) {
              tempSCData.flowName = "prospect accord move| mix match";
              flowName = "accord move + mix match";
            } else if (
              this.props.cust_opt === "SEAMLESS" &&
              this.props.isFCPflow &&
              !this.props.isFcpInProfile
            ) {
              tempSCData.flowName = "prospect accord seamless move";
              flowName = "prospect accord + seamless move";
            } else if (
              this.props.cust_opt === "SEAMLESS" &&
              this.props.isFCPflow &&
              this.props.isFcpInProfile
            ) {
              tempSCData.flowName = "prospect accord seamless move| mix match";
              flowName = "accord seamless move + mix match";
            } else if (
              this.props.isFCPflow &&
              this.props.cust_opt == null &&
              this.props.isFcpInProfile
            ) {
              tempSCData.flowName = "prospect accord move| mix match";
              flowName = "accord move + mix match";
            } else {
              tempSCData.flowName = "prospect accord move";
              flowName = "accord move";
            }
            updateFlowName(flowName)
            tempSCData.customerCategory = "^Moves^";
            updateSCcustomEvent(
              "accordionOpenMoves",
              "ddAddToCartEvent",
              "detailPageName,pageName"
            );
            updateVzdlSCCustomEvent(
              "accordionOpenMoves",
              "pageViewOmni",
              "detail"
            );
          } else {
            if (this.props.flowType === "SUPP") {
              tempSCData.contentChannel =
                "/vz/residential/myverizon/whats+next/fios/acrd supp order";
              updateSCcustomEvent(
                "accordionOpen",
                "ddAddToCartEvent",
                "detailPageName,pageName,contentChannel"
              );
              updateVzdlSCCustomEvent(
                "accordionOpen",
                "pageViewOmni",
                "detail"
              );
            } else {
              let notificationMessage = "";
              let vecFlow = this.props && this.props.lqState && this.props.lqState.ecLQResponse && (this.props.lqState.ecLQResponse.hoaFlag === "V" || this.props.lqState.ecLQResponse.hoaFlag === "Y") ? true : false;
              if(this.props?.lqState?.hoaFlowDetails?.isHoaFlow && this.props?.buildProduct?.hoabundle && InHomeUtils.isNotNull(this.props.buildProduct.hoabundle.hoaresponse) && InHomeUtils.isNotNull(this.props.buildProduct.hoabundle.hoaresponse.defaultMap)){
                notificationMessage = "As a Verizon Enhanced Communities Value Program customer, your offer includes ";
                if((name === "toggle_internet_plan_accor" || name === "toggle_internet_accor") && this.props.buildProduct.hoabundle.hoaresponse.defaultMap.internet && this.props.buildProduct.hoabundle.hoaresponse.defaultMap.internet != ""){
                  notificationMessage = notificationMessage + this.props.buildProduct.hoabundle.hoaresponse.defaultMap.internet;
                }
                else if(name === "toggle_phone_plan_accor" && vecFlow && this.props.buildProduct?.hoabundle?.hoaresponse?.defaultMap?.voice != undefined && this.props.buildProduct?.hoabundle?.hoaresponse?.defaultMap?.voice != ""){
                  notificationMessage = notificationMessage + this.props.buildProduct.hoabundle.hoaresponse.defaultMap.voice
                } 
                else if(name === "toggle_phone_accor"  && vecFlow && this.props?.buildProduct?.hoabundle?.hoaresponse?.defaultMap?.voice != undefined && this.props?.buildProduct?.hoabundle?.hoaresponse?.defaultMap?.voice !=""){
                  if(this.props.buildProduct.voice && this.props.buildProduct.voice.isSubAccordionOpen){
                    notificationMessage = notificationMessage + this.props.buildProduct.hoabundle.hoaresponse.defaultMap.voice
                  }
                  else{
                    notificationMessage = "";
                  }
                }  
                else if((name === "toggle_tv_accor" || name === "toggle_tv_plan_accor") && this.props.buildProduct.hoabundle.hoaresponse.defaultMap.video && this.props.buildProduct.hoabundle.hoaresponse.defaultMap.video != ""){
                  notificationMessage = notificationMessage + this.props.buildProduct.hoabundle.hoaresponse.defaultMap.video;
                }
                else if(name === "toggle_tv_settopbox_accor" && this.props.buildProduct.hoabundle.hoaresponse.defaultMap.vRoom && this.props.buildProduct.hoabundle.hoaresponse.defaultMap.vRoom != ""){
                  notificationMessage = notificationMessage + this.props.buildProduct.hoabundle.hoaresponse.defaultMap.vRoom;
                }
                else if(name === "toggle_tv_channel_accor" && this.props.buildProduct.hoabundle.hoaresponse.defaultMap.channel && this.props.buildProduct.hoabundle.hoaresponse.defaultMap.channel != ""){
                  notificationMessage = notificationMessage + this.props.buildProduct.hoabundle.hoaresponse.defaultMap.channel;
                }
                else{
                  notificationMessage = "";
                }
              }
              let updateTags = notificationMessage === "" ? "detail" : "notification, detail";
              let delayDuration = notificationMessage === "" ? 0 : 1000;
              updateSCcustomEvent(
                "accordionOpen",
                "ddAddToCartEvent",
                "detailPageName,pageName"
              );
              setTimeout(() => { 
                updateVzdlSCCustomEvent(
                  "accordionOpen",
                  "pageViewOmni",
                  updateTags,
                  false, "", false,
                  notificationMessage
                );
              }, delayDuration);
            }
          }
          if(name === 'toggle_internet_accor'){
            updateSCTags(`${title}:expanded`);
          }
          if(name === 'toggle_tv_accor'){
            updateSCTags('add live tv:expanded');
          }
          if(name === 'toggle_internet_perks_accor'){
            updateSCTags('perks:expanded');
          }
          if(name === 'toggle_internet_plan_accor'){
            updateSCTags('internet speed:expanded');
          }
          if(name === 'toggle_internet_router_accor'){
            updateSCTags('internet equipment:expanded');
          }
          if(name === 'toggle_data_splOffer_accor'){
            updateSCTags('Choose your offer:expanded');
          }
        }
        else {
          if(name === 'toggle_internet_accor'){
            updateSCTags(`${title}:collapsed`);
          }
          if(name === 'toggle_tv_accor'){
            updateSCTags('add live tv:collapsed');
          }
          if(name === 'toggle_internet_perks_accor'){
            updateSCTags('perks:collapsed');
          }
          if(name === 'toggle_internet_plan_accor'){
            updateSCTags('internet speed:collapsed');

          }
          if(name === 'toggle_internet_router_accor'){
            updateSCTags('internet equipment:collapsed');
          }
          if(name === 'toggle_data_splOffer_accor'){
            updateSCTags('Choose your offer:collapsed');
          }
        }
        this.checkProductsForLBO(name);
      }
    } catch (ex) {
      catchJSException(
        "BuildProduct",
        this.props.visitId,
        "accordionTitle-openAccordion",
        ex
      );
    }
  };

  checkProductsForLBO = (accName) => {
    let addlParam = {
      zip: this.props.zip,
      tarCode: this.props.tarcode,
      channelLineUpTvPackages: this.props.buildProduct.masterpackageview,
      isDoflow: false,
      couponFlowType: null,
      flowType: "",
      reAttemptCount: 2,
    };
    let suppHasSlingTV = this.props.suppHasSlingTV;
    if (
      accName.toLowerCase().indexOf("internet_accor") > -1 &&
      !this.props.buildProduct.internet.isAccordionOpen &&
      this.props.buildProduct.internet.isSubAccordionOpen &&
      this.props.buildProduct.internet.m2mPlans.length === 0
    ) {
      buildProductAction.prefetchPlansForFailedCase(
        this.props.dispatch,
        this.props.visitId,
        addlParam,
        "data"
      );
    } else if (
      !InHomeUtils.isNotNull(suppHasSlingTV) &&
      accName.toLowerCase().indexOf("tv_accor") > -1 &&
      !this.props.buildProduct.tv.isAccordionOpen &&
      this.props.buildProduct.tv.isSubAccordionOpen &&
      this.props.buildProduct.tv.m2mPlans.length === 0
    ) {
      buildProductAction.prefetchPlansForFailedCase(
        this.props.dispatch,
        this.props.visitId,
        addlParam,
        "video"
      );
    } else if (
      accName.toLowerCase().indexOf("phone_accor") > -1 &&
      !this.props.buildProduct.voice.isAccordionOpen &&
      this.props.buildProduct.voice.isSubAccordionOpen &&
      this.props.buildProduct.voice.plans.length === 0
    ) {
      buildProductAction.prefetchPlansForFailedCase(
        this.props.dispatch,
        this.props.visitId,
        addlParam,
        "voice"
      );
    }
  };

  mainTitle(props) {
    let title = "";
    if (props.name == "toggle_phone_plan_accor" && props.status == "added") {
      return (title = "Phone Plan");
    } else if (
      ( props.name == "toggle_phone_winbackcheck_accor" ||
        props.name == "toggle_phone_listing_accor" || props.name == "toggle_phone_backup_accor"
        ) &&
      props.status == "added"
    ) {
      //return (title = props.titleOmniName );
      return(title = props.title[0] === 'Voice Backup PowerReserve + Shipping' ? "I'd like a PowerReserve" : title = props.title[0] === 'Voice Backup PowerReserve Declined' ? "No, I don't want a PowerReserve" : props.title[0] === 'Listed and Published' ? "Directory Listing" : props.titleOmniName ? props.titleOmniName : 'Directory Listing');
    } 
    else if (
      props.name == "toggle_phone_intlplans_accor" &&
      props.status == "added"
    ) {
      return (title = "Call more international destinations");
    }else if (
      props.name == "toggle_phone_intlcalling_accor" &&
      props.status == "added"
    ) {
      return (title = "International calling");
    }
  }
  checkIfHoaFlow = () => {
    return this.props.lqState && this.props.lqState.hoaFlowDetails && this.props.lqState.hoaFlowDetails.isHoaFlow;
}
  subTitleReqText(props) {
    let subText = "";
    if (props.name == "toggle_phone_intlcalling_accor") {
      return (subText = "- Choose your international calling destination.");
    } else if (props.name == "toggle_phone_backup_accor") {
      return (subText =
        "- Get a backup battery-powered device for phone service.");
    } else if (props.name == "toggle_phone_listing_accor") {
      return (subText = "- List your number in a directory. ");
    } else if (props.name == "toggle_phone_winbackcheck_accor") {
      return (subText =
        "- Use your current phone number with your new service or get a new one.");
    } else if (props.name == "toggle_emergency_services_accor") {
      return (subText = "- Use this line to support a fire alarm.");
    } else if(props.name === 'toggle_data_splOffer_accor') {
      return subText = '- Choose one gift, included with your plan.';
    } 
  }

  AccTitleaddText(props){
    let subText = "";
    let perkscnt = 0;
    let vecFLow = InHomeUtils.isNotNull(this.props.lqState) && InHomeUtils.isNotNull(this.props.lqState.ecLQResponse) && (this.props.lqState.ecLQResponse.hoaFlag === "V" || this.props.lqState.ecLQResponse.hoaFlag === "Y");
    if(props.name == "toggle_internet_accor"){
       subText = props.buildProduct?.internet?.selectedProduct?.name ? '[' + props.buildProduct?.internet?.selectedProduct?.name + ']' : "";
        if(subText == '' && this.props?.ecProfileCart?.ProfileDataProduct?.prodName!= '') {
        subText = '[' + this.props?.ecProfileCart?.ProfileDataProduct?.prodName + ']'
       }
      perkscnt = (props.buildProduct.perks.selectedProduct != null)
        ? props.buildProduct?.perks?.selectedProduct?.length
        : Array.isArray(props?.cart?.cartData?.[0]?.perks?.perks)
          ? props.cart.cartData[0].perks.perks.length
          : 0;
      return subText?.toString()?.replace('4.0', '')?.replace('4.1', '')?.replaceAll("&reg;", "\u00AE");
    } else if(props.name == "toggle_tv_accor") {
      let selectedProd = props?.buildProduct?.tv?.selectedProduct?.name || '';
      selectedProd = (this.props.buildProduct?.isECMNEnabled && !this.props.selectedProduct && !["Add TV", "TV"].includes(this.props?.title  || this.props.profileCartProduct?.accordionTitle || this.props.profileCartProduct?.name)) 
      ? (this.props?.title || this.props.profileCartProduct?.accordionTitle || this.props.profileCartProduct?.name) : '';
      const selectedProdSubText = selectedProd?.toString()?.replace('4.0', '')?.replace('4.1','')?.replaceAll("&reg;", "\u00AE");

      return `${selectedProdSubText ? `[${selectedProdSubText}]` : ''}`;
    } else if(props.name == "toggle_phone_accor") {
      let selectedProd ;
      if(vecFLow){
        selectedProd = props?.voiceSelectedProduct?.name !== "" ? "[" + props?.voiceSelectedProduct?.name +"]" :"";
      }
      else{
        selectedProd = props?.buildProduct?.voice?.selectedProduct?.name || '';
      }
      const selectedProdSubText = selectedProd?.toString()?.replace('4.0', '')?.replace('4.1', '')?.replaceAll("&reg;", "\u00AE") || '';

      if (selectedProdSubText.toLowerCase().trim() === 'home phone') {
        return `Fios ${selectedProdSubText}`
      } else {
        return selectedProdSubText;
      }
    } else {
      return 'Added';
    }
  }

  subTitleOptText(props) {
    let subText = "";
    if (
      props.name == "toggle_phone_intlplans_accor" &&
      props.status == "optional"
    ) {
      return (subText = "Optional - Choose Verizon World Plan.");
    } else if (
      props.name == "toggle_emergency_services_accor" &&
      props.status == "optional"
    ) {
      return (subText = "Optional - Use this line to support a fire alarm.");
    } else if (props.name == "toggle_internet_techsure_accor") {
      return (subText = props?.buildProduct?.techsure?.selectedProduct?.length > 0 ? "" : 'Optional');
    } else if (props.name == "toggle_internet_fne_accor") {
      return (subText = "");
    } 
    // else if (props.name == "toggle_phone_accor" && this.checkIfHoaFlow() && !props.isAccordionOpen) {
    //   return (subText = "[" + props?.ecProfileCart?.ProfileVoiceProduct?.prodName+ "]");
    // } 
    else if (props.name == "toggle_phone_accor" && props?.Voicesubtitle) {
      return (subText = props?.Voicesubtitle);
    } 
    else if(props.name == "toggle_internet_home_techsure_accor"){
      return (subText = props.buildProduct?.vhsBiller?.selectedProduct?.length>0 ? "": "Optional");
    } else if (props.name === 'toggle_tv_settopbox_accor'){
      if(this.checkIfHoaFlow() && this.props.buildProduct.vRoom.unitCount > 1){
        return subText = (this.props.buildProduct.vRoom.unitCount + ' set-top boxes');
      } else if (this.checkIfHoaFlow() && this.props.buildProduct.vRoom.unitCount == 1){
        return subText = (this.props.buildProduct.vRoom.unitCount + ' set-top box');
      } else if(this.checkIfHoaFlow() && this.props.buildProduct.vRoom.unitCount == 0 ){
        let defaultFinalizeText = '';
        if(this.props?.buildProduct?.hoabundle?.hoaresponse?.defaultMap['vRoom'] !=='' && this.props?.buildProduct?.hoabundle?.hoaresponse?.defaultMap['vRoom'] !== undefined && this.props?.buildProduct?.hoabundle?.hoaresponse?.defaultMap['vRoom'] !== null){
          let vRoomValue = this.props?.buildProduct?.hoabundle?.hoaresponse?.defaultMap['vRoom'];
          let setDefaultValue = (this.props?.buildProduct?.hoabundle?.hoaresponse?.defaultMap['vRoom'].indexOf("Fios TV Connections") > 0);
         
          if(setDefaultValue > 0){
            defaultFinalizeText= vRoomValue.replace("Fios TV Connections", "Set-top boxes");
          } else {
            defaultFinalizeText= vRoomValue.replace("Fios TV Connection", "Set-top box");
          }
        } else {
          defaultFinalizeText = ('Optional - Choose your number of TV connections.');
        }
        
        return subText = (defaultFinalizeText);
      }
     
      
    } else if (props.name === 'toggle_tv_recording_accor' ){
      let recordingsubTitle=this.props.buildProduct?.recording?.equipments?.filter(equipment => equipment.isprdOnProfile)
      if(recordingsubTitle?.length>0){
        return (subText = `${recordingsubTitle?.[0]?.name}`);
      }
      else{
        return (subText = "Optional - Choose your recording service.")
      }
    } else if(this.checkIfHoaFlow() && (props.name == "toggle_internet_accor" || props?.ecProfileCart?.ProfileDataProduct?.editLink==="dataplans") && props?.buildProduct?.internet?.selectedProduct==null){
      return subText = this.props?.ecProfileCart?.ProfileDataProduct?.prodName;
    } else if(this.checkIfHoaFlow() && (props.name == "toggle_tv_accor") && props?.buildProduct?.tv?.selectedProduct==null){
      return subText = this.props?.ecProfileCart?.ProfileTVProduct?.prodName;
    }
    
  }


  subTitleOptTextTV(props) {
    let subText = "";
    if(props.name == 'toggle_internet_perks_accor'){
      return (subText = (this.props.buildProduct.isECMNEnabled && !this.props?.buildProduct?.internet?.selectedProduct && !this.props?.ecProfileCart?.ProfileDataProduct) ? 'Optional - Please select internet plan first.' : (this.props.flowType === 'SUPP' && this.props.cart?.cartData[0]?.perks?.perks?.length > 0 ?  props?.cart?.cartData[0]?.perks?.perks?.map(p => p?.name || p?.accordionTitle || p?.prodName)?.join("+ ") :  "Optional - Choose your perks." ));
    } else if(props.name == 'toggle_tv_internationalchannel_accor'){
      
        return (subText = "Optional - Choose your international channels.");
   
    } else if(props.name == 'toggle_tv_channel_accor'){
      if(this.checkIfHoaFlow() && this.props?.buildProduct?.hoabundle?.hoaresponse?.defaultMap['channel'] !=='' && this.props?.buildProduct?.hoabundle?.hoaresponse?.defaultMap['channel'] !== undefined && this.props?.buildProduct?.hoabundle?.hoaresponse?.defaultMap['channel'] !== null){
        return subText = (this.props?.buildProduct?.hoabundle?.hoaresponse?.defaultMap['channel']);
      } else {
        return (subText = "Optional - Choose your favorite premium channels.");
      }
    } else if(props.name == 'toggle_tv_ceapps_accor'){
      return (subText = "Optional - Choose your streaming device.");
    } else if (props.name === 'toggle_tv_recording_accor'){
      return (subText = "Optional - Choose your recording service.");
    }
  }

  subTitleaddText(props) {
    let subText = "";
    if (
      (props.name == "toggle_phone_intlplans_accor" ||
      props.name == "toggle_phone_backup_accor" ||
        props.name == "toggle_phone_listing_accor" ||
        props.name == "toggle_phone_winbackcheck_accor") &&
      props.status == "added"
    ) {
      return (subText = props.title[0]);
    } 
    else if (
      props.name == "toggle_phone_intlcalling_accor" &&
      props.status == "added"
    ) {
      return (subText = "Included - " + props?.buildProduct?.intlCalling?.selectedProduct?.countryName);
    } else if(props.name == "toggle_tv_plan_accor"){
      if(this.props?.title || this.props.profileCartProduct?.accordionTitle || this.props.profileCartProduct?.name){
        return (subText = this.props.title);
      }else{
        return (subText = "Choose Live TV");
      }
    } else if(props.name == "toggle_phone_plan_accor" && props.status == "added"){
      return (subText =  this.props.title[0] );
    }
  }

  getSubTitleReqString = () => {
    if(this.props.buildProduct.isECMNEnabled && this.props.name !== 'toggle_internet_router_accor') {
      if(this.props.name !== "toggle_tv_router_accor") {
        return 'Required';
      } else {
        return 'Choose your router';
      }
    } else {
      if(this.props.name === 'toggle_tv_settopbox_accor' || this.props.name === 'toggle_tv_recording_accor') {
        return 'Required';
      } else {
        return 'Included with your plan';
      }
    }
  }

  getAccIcon = () => {
    switch(this.props.name) {
      case 'toggle_internet_accor': 
      return (<WifiIcon 
            size="large" ariaHidden="true"
            />);
      case 'toggle_tv_accor': 
      return (<Tv 
        size="large" ariaHidden="true"
        />);
      case 'toggle_phone_accor': 
      return (<Phone 
        size="large" ariaHidden="true"
        />);
      case 'toggle_contract_accor': 
      return (<ComplianceIcon 
        size="large" ariaHidden="true"
        />);
      case 'toggle_splOffer_accor': 
      return (<GiftIcon 
        size="large" ariaHidden="true"
        />);
      case 'toggle_internet_perks_accor':
        return (<ServicesIcon 
          size="large" ariaHidden="true"
          />);  
      default: 
        return(<></>);
    }
  };

  getClassName = () => {
    let className = '';
    switch(this.props.name) {
      case 'toggle_internet_accor': 
      className = `${this.props.buildProduct.isECMNEnabled ? 'ecTitleSpacing_supp':'ecTitleSpacing'}`
      break;
      case 'toggle_tv_accor': 
      className = `${this.props.buildProduct.isECMNEnabled ? `'ecTitleSpacing_supp' ${'accorTitleheight'}` :'ecTitleSpacing'}`
      break;
      case 'toggle_phone_accor': 
      className = `${this.props.buildProduct.isECMNEnabled ? `'ecTitleSpacing_supp' ${'accorTitleheight'}`:'ecTitleSpacing'}`
      break;
      // case 'toggle_contract_accor': className = 'compliance-document';
      // break;
      // case 'toggle_internet_perks_accor': className = 'services';
      // break;
      default: className = `${(this.props.buildProduct.isECMNEnabled && this.props.flowType === "SUPP") ? 'ecTitleSpacing_subAccr_supp' : 'ecTitleSpacing_subAccr'}`
      break;
    }
    return className;
  };

  suppFlowtitle(props){
    let subText = "";
    subText = props.cart?.cartData[0]?.perks?.perks?.length > 0 ?
    props?.cart?.cartData[0]?.perks?.perks?.map(p => p?.name || p?.accordionTitle || p?.prodName)?.join("+ ") : '';
    
    return subText;
     
  }

  

  render() {
    let actionStatus = "",
      headerStatusClass = "required_ribbon normal-weight";
    let mm3Qualified = this.props.buildProduct.internet.mm3Qualified;
   if (this.props.status === AccordionStatus.required) {
      actionStatus = (
        <span className={`m_required ${this.props.buildProduct.isECMNEnabled ? 'm_added_reskin_monarch' : 'm_added_reskin'}`}>
          {/* <Title viewport="mobile"  primitive="span" color="#cd040b">
          Required
        </Title> */}
          {this.props.isAccordionOpen && (
            <UpcaretIcon color="#000" size="large" ariaHidden="true" />
          )}
          {!this.props.isAccordionOpen && (
            <DowncaretIcon
              color="#000"
              size="large"
              ariaHidden="true"
            />
          )}
        </span>
      );
      headerStatusClass = "required_ribbon normal-weight required";
    } else if (this.props.isAccordionOpen) {
      headerStatusClass = "required_ribbon normal-weight added";
      actionStatus = (
        <span className={`m_added ${this.props.buildProduct.isECMNEnabled ? 'm_added_reskin_monarch' : 'm_added_reskin'}`}>
          {/* <Title viewport="mobile"  primitive="span" color="#00AD3E">
          Added
        </Title> */}
          <UpcaretIcon color="#000" size="large" ariaHidden="true" />
        </span>
      );
    } else if (!this.props.isAccordionOpen) {
      headerStatusClass = "required_ribbon normal-weight added";
      actionStatus = (
        <span className={`m_added ${this.props.buildProduct.isECMNEnabled ? 'm_added_reskin_monarch' : 'm_added_reskin'}`}>
          {/* <Title viewport="mobile"  primitive="span" color="#00AD3E">
          Added
        </Title> */}
          <DowncaretIcon ariaHidden="true" color="#000" size="large" />
        </span>
      );
    } else if (this.props.status === AccordionStatus.completed) {
      headerStatusClass =
        "required_ribbon normal-weight headingstatuscompleted";
      actionStatus = (
        <span className="m_headingadded">
          <Title viewport="mobile" primitive="span" color="#00AD3E">
            Added
          </Title>
        </span>
      );
    } else if (this.props.status === AccordionStatus.actionRequired) {
      actionStatus = (
        <span className="m_actionrequired">
          <Title viewport="mobile" primitive="span" color="#ed7000">
            Action Required
          </Title>
        </span>
      );
      headerStatusClass = "required_ribbon normal-weight headingstatusrequired";
    } else if (this.props.status === AccordionStatus.reviewRequired) {
      actionStatus = (
        <span className="m_reviewrequired">
          <Title viewport="mobile" primitive="span" color="#ed7000">
            Review Required
          </Title>
        </span>
      );
    } else if (this.props.status === AccordionStatus.optional) {
      actionStatus = (
        <span className="t_optional">
          {/* <Title viewport="mobile" primitive="span" color="#747676">
            Optional
          </Title> */}
          <UpcaretIcon color="#000" size="large" />
        </span>
      );
      headerStatusClass = "required_ribbon normal-weight headingoptional";
    } else {
      headerStatusClass = "required_ribbon normal-weight added";
      actionStatus = (
        <span className={`m_added ${this.props.buildProduct.isECMNEnabled ? 'm_added_reskin_monarch' : 'm_added_reskin'}`}>
          {/* <Title viewport="mobile"  primitive="span" color="#00AD3E">
          Added
        </Title> */}
          <DowncaretIcon color="#000" size="large" />
        </span>
      );
    }

    let promoInfo = "";
    let isHidePromo = false;
    if (
      InHomeUtils.isNotNull(this.props.isHidePromo) &&
      this.props.isHidePromo === "true"
    ) {
      isHidePromo = true;
    }
    if (!isHidePromo) {
      let isCartData =
        InHomeUtils.isNotNull(this.props.cart) &&
        InHomeUtils.isNotNull(this.props.cart.cartData) &&
        this.props.cart.cartData.length > 0
          ? true
          : false;

      if (
        isCartData &&
        InHomeUtils.isNotNull(this.props.locationId) &&
        this.props.locationId !== ""
      ) {
        promoInfo = (
          <PromoContent
            locationId={this.props.locationId}
            cartData={this.props.cart.cartData[0]}
            buildProductContent={this.props.buildProduct}
          />
        );
      }
    }
    
    let isProgressBarPresent =
      this.props?.lqState?.runtimeKey?.displayProgressBar === "Y" &&
      window.showProgressBar === "Y" &&
      this.props.buildProduct.isProgressBarDisplayed
        ? true
        : false;
    let isReskin =
      this.props.buildProduct.isReskin &&
      this.props.lqState &&
      this.props.lqState.runtimeKey &&
      this.props.lqState.runtimeKey.EnableReskin === "Y";
    let accordionTitleName =
      this.props.title &&
      this.props.title[0] &&
      this.props.title[0].indexOf("Fios TV Connection") > -1
        ? this.props.buildProduct.vRoom.unitCount > 1
          ? this.props.title[0].replace("Fios TV Connections", "Set-top boxes")
          : this.props.title[0].replace("Fios TV Connection", "Set-top box")
        : (this.props.name === "toggle_phone_plan_accor" &&
            this.props.status == "added") ||
          (this.props.name === "toggle_phone_intlcalling_accor" &&
            this.props.status == "added") ||
          (this.props.name === "toggle_phone_intlplans_accor" &&
            this.props.status == "added") ||
          (this.props.name === "toggle_phone_winbackcheck_accor" &&
            this.props.status == "added") ||
          (this.props.name === "toggle_phone_listing_accor" &&
            this.props.status == "added") ||
          (this.props.name === "toggle_phone_backup_accor" &&
            this.props.status == "added")
        ? this.mainTitle(this.props)
        : (this.props.title?.[0]?.indexOf("Customer owned Quantum") > -1 ? this.props.buildProduct.router.selectedProduct.accordionTitle : (this.props.name === "toggle_phone_backup_accor" ? (this.props.title === "PowerReserve" ? "PowerReserve" : this.props.title === "No, I don't want a PowerReserve" ? "I don't want a PowerReserve" : "I'd like a PowerReserve") : this.props.title));

    const accordionName = (accordionTitleName || '')?.toString()?.replace('4.0', '')?.replace('4.1', '')?.replaceAll("&reg;", "\u00AE")?.replace('Choose','')?.replace("<sup>", "")?.replace("</sup>", "")?.replace("Disney+ Premium +  Hulu +  ESPN+", 'Disney+ Premium, Hulu, ESPN+') || ''
    let accordionTitle = '';
    if (accordionName.toLowerCase().trim() === 'tv') {
      accordionTitle = `${accordionName}`;
    } else if (accordionName.toLowerCase().trim() === 'home phone') {
      accordionTitle = `Phone`;
    } else if(this.props?.name === 'toggle_internet_perks_accor' && this.props?.fromPerkTitle) {
      accordionTitle = 'Perks';
    } else if(accordionName.toLowerCase().trim() === 'add premium channels') {
      accordionTitle = 'Premium Channels';
    }
     else if(this.props?.name === 'toggle_tv_accor'){
      accordionTitle = accordionName.includes("Add") ? accordionName : 'TV'
      }
    else if(this.props?.name === 'toggle_tv_plan_accor') {
      accordionTitle = 'TV plan';
    } else if(this.props.name === 'toggle_tv_settopbox_accor') {
      accordionTitle = 'TV connections';
    } else if(this.props.name === 'toggle_internet_accor') {
      accordionTitle = 'Internet';
    } 
    else if(this.props.name === 'toggle_internet_fne_accor') {
      let products=this.props?.buildProduct?.fne?.equipments;
      for(let product of products){
        if(product?.id ==="R4067" && product?.isChecked){
          accordionTitle="Fios Extender";
         break
        }
        else if((product?.id==="R4064"||product?.id==="R4065"||product?.id==="R4066")&&product?.isChecked){
          accordionTitle="Rent: Fios Extender";
          break
        }
        else {
          accordionTitle = accordionName;
          
        }
      }



    
    
  }else {
      accordionTitle = accordionName;
    }
    
    let accordionTitleChangeFlow = '';
    if (accordionName.toLowerCase().trim() === 'tv') {
      accordionTitleChangeFlow = `${accordionName}`;
    } else if (accordionName.toLowerCase().trim() === 'home phone') {
      accordionTitleChangeFlow = `Phone`;
    } else if(this.props?.name === 'toggle_internet_perks_accor') {
      let perksSelected = this.props?.ecProfileCart?.cartData?.[0]?.perks?.length === 0 && ( this.props?.cart?.cartData === null || this.props?.cart?.cartData?.[0]?.perks?.length === 0 ) && this.props?.fromPerkTitle;
      accordionTitleChangeFlow = perksSelected ? 'Add Perks' : 'Perks';
    } else if(accordionName.toLowerCase().trim() === 'add premium channels' || this.props.name === 'toggle_tv_channel_accor') {
      accordionTitleChangeFlow = 'Premium Channels';
    } else if(this.props.name === 'toggle_internet_plan_accor') {
      accordionTitleChangeFlow = 'Internet speed';
    } else if(this.props.name === 'toggle_internet_router_accor') {
      accordionTitleChangeFlow = window?.sessionStorage?.getItem('isWIFI7') === 'true' ? 'Manage current internet equipment' : 'Internet router'; 
    } else if(this.props.name === 'toggle_internet_access_point_accor') {
      accordionTitleChangeFlow = this.props?.buildProduct?.router?.equipments?.length > 0 ? 'Upgrade your internet equipment' : 'Manage your internet equipment'; 
    } else if(this.props.name === 'toggle_tv_settopbox_accor') {
      accordionTitleChangeFlow = 'TV connections';
    } else if(this.props.name === 'toggle_tv_plan_accor') {
      accordionTitleChangeFlow = 'TV plan';
    } else if(this.props.name === 'toggle_tv_channel_accor') {
      accordionTitleChangeFlow = 'Premium Channels';
    } else if(this.props.name === 'toggle_tv_recording_accor'){
      accordionTitleChangeFlow = 'Recording Service';
    } else if (this.props.name == 'toggle_tv_internationalchannel_accor'){
      accordionTitleChangeFlow = 'International Channels';
    } else {
      accordionTitleChangeFlow = accordionName;
    }

    let isClassicOrMM3Flow = !mm3Qualified && !this.props.buildProduct?.isMNEnabled ? "classicFlow " : "mm3Flow ";
    let accRevealClass ="   "
    if(this.props.buildProduct?.isECMNEnabled && this.props.name == "toggle_phone_intlcalling_accor" && this.props.status == "added"){
      accRevealClass = 'accordion_blocks-reveal_monarch subtitle-country-added'
    }
    else if(this.props.buildProduct?.isECMNEnabled && this.props.name == "toggle_phone_intlcalling_accor" && this.props.status != "added"){
      accRevealClass = 'accordion_blocks-reveal_monarch subtitle-country'
    }
    else{
      accRevealClass = this.props.buildProduct?.isECMNEnabled ? 'accordion_blocks-reveal_monarch' : 'accordion_blocks-reveal';
    }

// https://onejira.verizon.com/browse/PRODDEF-38439
    // Sub Header should be whatever is selected...Router Only, Use Your Own Router, or Buy: Verizon Router etc.
    const internetRouter = (this.props?.buildProduct?.router?.selectedProduct?.accordionTitle?.replace('4.0', '')?.replace('4.1', '')?.replaceAll("&reg;", "\u00AE") || '')?.toString().trim();
    const accordionSubTitle = ((this.props?.name || '').trim() === 'toggle_internet_router_accor' && internetRouter === 'Rent: Verizon Router') ? 'Router Only' : internetRouter
    accordionTitleName = ((this.props?.name || '').trim() === 'toggle_internet_router_accor' && (accordionTitleName || '')?.toString().trim() === 'Rent: Verizon Router') ? 'Router Only' : accordionTitleName;
    
    let template = (
      <div
        id={this.props.name}
        ref={(e) => (this.props.inputelementRef[this.props.name] = e)}
        onKeyDown={(e) =>
          this.handleKeyDown(
            e,
            this.props.name,
            this.props.title,
            this.props.titleOmniName
          )
        }
        onClick={(e) =>
          this.openAccordion(
            e,
            this.props.name,
            this.props.title,
            this.props.titleOmniName
          )
        }
        className={
          this.props.name != "toggle_internet_accor" &&
          this.props.name != "toggle_tv_accor" &&
          this.props.name != "toggle_internet_perks_accor" &&
          this.props.name != "toggle_phone_accor"
            ? this.props.isAccordionOpenRequired === false
              ? `${accRevealClass} accordion_blocks-revealRskn ${isClassicOrMM3Flow}`
              : this.props.isAccordionOpen
              ? `${accRevealClass} accordion_blocks-revealRskn accordionWrapperReskin open ${isClassicOrMM3Flow}`
              : `${accRevealClass} accordion_blocks-revealRskn accordionWrapperReskin close ${isClassicOrMM3Flow}`
            : this.props.isAccordionOpenRequired === false
            ? `${accRevealClass} HeadRskn HeadRskn_EC`
            : this.props.isAccordionOpen
            ? `${accRevealClass} accordion_blocks-revealRskn   ${isClassicOrMM3Flow} paddingLeftPerk`
            : `${accRevealClass} accordion_blocks-revealRskn close HeadRskn_EC HeadRskn ${'tvAccordionChangeFlowAccordion'} ${isClassicOrMM3Flow}`
        }
        data-reveal-toggle-class="close open"
        data-internet-options=""
        data-reveal-group="OrderingAccordion"
        style={{
          borderTop: isProgressBarPresent && !isReskin && "1.5px solid black",
         
        }}
      >
        <div
          // className={`accord-acc-wrapper pointer accordionWrapperRskn ${this.props.name === 'toggle_internet_accor' ? this.props.buildProduct.isECMNEnabled ? 'ecTitleSpacing_supp':'ecTitleSpacing' : this.props.buildProduct.isECMNEnabled ? 'ecTitleSpacing_subAccr_supp' : 'ecTitleSpacing_subAccr'} ${ this.props.name === 'toggle_phone_accor' || this.props.name === 'toggle_tv_accor' ? 'tvAccordionChangeFlow' : '' }`}
          className={`accord-acc-wrapper pointer accordionWrapperRskn emregencyserv-title  ${this.getClassName()} ${this.props.name === 'toggle_phone_plan_accor' ? 'unsetHeight' : ''} ${this.props.name === 'toggle_internet_perks_accor' ? 'paddingAccorPerkLeft' : ''} `}

          id={this.props.serviceType === "TV"? "focus3" : "focus2" }
          tabIndex={this.props.isAccordionDisabled ? "-1" : "0"}
          role="button"
          aria-hidden={this.props.isAccordionDisabled}
          aria-expanded={this.props.isAccordionOpen}
        >
          <div
            className={(this.props.buildProduct.isECMNEnabled && !this.props.buildProduct.isClassicAccount) ? "padding-horiz-zero" : "padding-horiz-zero headline-wrapper headlineWrapperRskn"}
          >
            <div
              className={`headline-content HdrInternet text-black ${this.props.name=== 'toggle_phone_plan_accor' ? 'padding-left-phone' : 'padding-left-tiny'}`}
              id={this.props.id}
            >
              {/* <Title viewport="mobile" primitive="h3" color="black">
              {this.props.title}
            </Title> */}
            <AccordionTitle primitive="h2"><span style={{fontSize: '16px', fontFamily: "Verizon NHG eDS", fontWeight: 700}} className={(this.props.name === "toggle_internet_accor" || this.props.name === "toggle_tv_accor" || this.props.name === "toggle_phone_accor" || this.props.name === 'toggle_contract_accor' || this.props.name === 'toggle_splOffer_accor' || (this.props.name === 'toggle_internet_perks_accor' && this.props?.fromPerkTitle)) ? 'HeaderIcon' : 'HeaderIcon hide'}>
            {this.getAccIcon()}
            {/* <Icon 
            name={this.getAccIcon()}
            size="large" ariaHidden="true"
            />  */}
            </span>  
            {/* {((this.props.flowType === 'SUPP' && this.props.name === 'toggle_internet_perks_accor' ) ? accordionTitleChangeFlow: accordionTitleChangeFlow)} */}
           {((( this.props?.name === 'toggle_internet_plan_accor') || (this.props?.name === 'toggle_internet_router_accor') || (this.props?.name === 'toggle_internet_access_point_accor') || (this.props?.name === 'toggle_internet_perks_accor') || (this.props?.name === 'toggle_tv_channel_accor') || (this.props.name === 'toggle_tv_recording_accor')  ||this.props.name == 'toggle_tv_internationalchannel_accor') ? accordionTitleChangeFlow:accordionTitle)}
           {this.props?.flowType !== 'SUPP' ? <div className="perksAccordionBelowText">{(this.props?.name == 'toggle_internet_perks_accor' && !this.props?.isAccordionOpen ?  this.props?.cart?.cartData?.[0]?.perks?.perks?.map(p => p?.name || p?.accordionTitle || p?.prodName)?.join(", ") : "")} </div>:""}
            </AccordionTitle>

            {this.props.buildProduct && this.props.buildProduct.pendingProdNotification && this.props.status === '' &&
            <AccordionSubTitle> <span>{ (this.props.name === 'toggle_phone_plan_accor' && !this.props.buildProduct.isMNEnabled) ? 'Choose your phone plan.': ''}</span></AccordionSubTitle>}
            <AccordionSubTitle>
        {(this.props.name==='toggle_tv_plan_accor' && this.props.status ==='added')?(this.props.buildProduct?.tv?.selectedProduct?.name?(this.props.selectedProduct?.accordionTitle || this.props.selectedProduct?.name)?.replace('4.1', '')?.replaceAll("&reg;", "\u00AE"):''):''}
      </AccordionSubTitle>
              {this.props.buildProduct && this.props.buildProduct.pendingProdNotification && this.props.status === AccordionStatus.required || (this.props?.name === 'toggle_internet_router_accor' && this.props?.buildProduct?.accessPoint?.selectedProduct === null)
                && <AccordionSubTitle>
                  
                  <span style={{ color: (this.props?.name !== 'toggle_internet_router_accor' && this.props?.name !== 'toggle_tv_router_accor') ? '#C44904' : '', paddingRight:'5px' }}>{ this.props?.name !== 'toggle_internet_router_accor' ? (this.props?.name !== "toggle_tv_router_accor" ? 'Required' : 'Choose your router') : ''}</span> 
                  <span>{ this.props.name === 'toggle_sploffer_accor' ? ' - Choose one gift, included with your plan.': ''}</span>
                  <span>{ this.props.name === 'toggle_tv_settopbox_accor' ? '- Choose your number of TV connections.': ''}</span>
                  <span>{ this.props.name === 'toggle_internet_access_point_accor' ? `- ${this.props?.title}`: ''}</span>
                  
                  {this.subTitleReqText(this.props)}
                </AccordionSubTitle>}
              {this.props.selectedProduct && (this.props.selectedProduct.price === 'Included' || (this.props.selectedProduct[0] && this.props.selectedProduct[0].price) === 'Included' || (this.props.RecorderIncluded))
                ? 
                <AccordionSubTitle>
                 
                  {this.props.isMNEnabled
                    ?    (this.props.name === "toggle_tv_recording_accor" ? 'Included '+this.props.selectedProduct?.name?.replace('4.0', '')?.replace('4.1','')?.replaceAll("&reg;", "\u00AE"): this.props.selectedProduct?.name?.replace('4.0', '')?.replace('4.1', '')?.replaceAll("&reg;", "\u00AE") )|| (this.props.name === "toggle_internet_router_accor" ? 'Included - '+this.props.selectedProduct?.accordionTitle?.replace('4.0', '')?.replace('4.1', '')?.replaceAll("&reg;", "\u00AE") : this.props.selectedProduct?.accordionTitle?.replace('4.0', '')?.replace('4.1', '')?.replaceAll("&reg;", "\u00AE") )|| this.props.selectedProduct?.prodName?.replace('4.0', '')?.replace('4.1', '')?.replaceAll("&reg;", "\u00AE")
                    : (this.props.name === "toggle_tv_ceapps_accor" ?  'Included - Unlimited' : (this.props.name === 'toggle_tv_settopbox_accor' ? this.checkIfHoaFlow() ?  this.props.buildProduct.vRoom.unitCount > 1? 'Included - '+ this.props.buildProduct.vRoom.unitCount+ ' Set-top boxes ' :'Included - '+ this.props.buildProduct.vRoom.unitCount+ ' Set-top box' : 'Added' : 'Included'))
                  }
                </AccordionSubTitle>
                : this.props.status === AccordionStatus.completed
                  ? <AccordionSubTitle> {this.AccTitleaddText(this.props)} </AccordionSubTitle>
                  : this.props.status === AccordionStatus.actionRequired
                    ? <AccordionSubTitle>
                      {!this.props.isMNEnabled && <span className='ec_phone_backup_accor'>Required</span>}
                    </AccordionSubTitle>
                    : <AccordionSubTitle>
                      {this.props.status === AccordionStatus.added
                        ? (this.props.name === "toggle_phone_intlplans_accor" || this.props.name === "toggle_phone_intlcalling_accor" || this.props.name === 'toggle_phone_winbackcheck_accor' || this.props.name === 'toggle_phone_listing_accor' || this.props.name === 'toggle_phone_backup_accor' || this.props.name === 'toggle_phone_plan_accor' )
                          ? this.subTitleaddText(this.props) : (this.props.name === "toggle_internet_home_techsure_accor" && this.props?.buildProduct?.vhsBiller?.selectedProduct ===  null) ? ""
                          : this.props.isMNEnabled
                            ? Array.isArray(this.props.selectedProduct) && this.props.selectedProduct.length > 0
                              ? this.props.selectedProduct.map(p => p?.name || p?.accordionTitle || p?.prodName).join(", ")?.replace('4.0', '')?.replace('4.1', '')?.replaceAll("&reg;", "\u00AE")
                              : (this.props.selectedProduct?.accordionTitle !== undefined && this.props.name === "toggle_internet_router_accor") ? accordionSubTitle
                              : this.props.selectedProduct?.name?.replace('4.0', '')?.replace('4.1', '')?.replaceAll("&reg;", "\u00AE") === 'Streaming' ? '1 Gig' : ( (this.props.name === "toggle_tv_recording_accor" || this.props.name === "toggle_internet_router_accor") ? 'Included - '+this.props.selectedProduct?.name?.replace('4.0', '')?.replace('4.1', '')?.replaceAll("&reg;", "\u00AE")  : this.props.selectedProduct?.name?.replace('4.0', '')?.replace('4.1', '')?.replaceAll("&reg;", "\u00AE")) || this.props.selectedProduct?.accordionTitle?.replace('4.0', '')?.replace('4.1', '')?.replaceAll("&reg;", "\u00AE") || this.props.selectedProduct?.accordionTitle?.replace('4.0', '')?.replace('4.1', '')?.replaceAll("&reg;", "\u00AE")
                            : (this.props.name === "toggle_internet_perks_accor") ? this.props.cart?.cartResponse?.tierContent?.[0]?.sections?.section?.find(s => s?.sectionName === "Perks")?.subSections?.subSection?.find(s => s?.sectionType === "Perks")?.products?.map(p => p?.accordionTitle || p?.name || p?.prodName)?.join(", ") || this.props.profileCart?.cartResponse?.tierContent?.[0]?.sections?.section?.find(s => s?.sectionName === "Perks")?.subSections?.subSection?.find(s => s?.sectionType === "Perks")?.products?.map(p => p?.accordionTitle || p?.name || p?.prodName)?.join(", ") || accordionTitle : '' 
                            || (this.props.name === 'toggle_data_splOffer_accor' ? ('Included4 - '+ this.props.buildProduct?.sploffer?.selectedProduct?.OfferText?.replace('Fios','Xbox')) : (this.props.name === 'toggle_tv_channel_accor' && this.props?.buildProduct?.channel?.selectedProduct.length > 1 ) ? this.props?.buildProduct?.channel?.selectedProduct?.filter((item) => !item?.prodName?.includes("Pick Your Premiums") && item)?.map(p => p?.prodName).join('&') : 'Included3 - '+accordionTitle ? this.props.name === 'toggle_internet_plan_accor' ? `[`+accordionTitle +`]` : this.props.name === 'toggle_tv_settopbox_accor' ?  
                            this.checkIfHoaFlow()? this.subTitleOptText(this.props):this.props.title : this.props.name === 'toggle_tv_plan_accor' ? (this.props?.buildProduct?.tv?.selectedProduct?.accordionTitle != null ? this.props?.buildProduct?.tv?.selectedProduct?.accordionTitle?.replace('4.0', '').replace('4.1', '').replaceAll("&reg;", "\u00AE") : (this.props?.buildProduct?.tv?.selectedProduct?.name?.includes("4.0") || this.props?.buildProduct?.tv?.selectedProduct?.name?.includes("4.1")) ? this.props?.buildProduct?.tv?.selectedProduct?.name?.replace('4.0', '')?.replace('4.1', '')?.replaceAll("&reg;", "\u00AE") : this.props?.buildProduct?.tv?.selectedProduct?.name ) : this.props.name === "toggle_internet_router_accor" && this.props?.buildProduct?.router?.selectedProduct?.accordionTitle?.indexOf("Customer owned Quantum") > -1 ? <span dangerouslySetInnerHTML={{ __html: accordionSubTitle }}></span>: this.props.name === "toggle_internet_router_accor" ? window?.sessionStorage?.getItem('isWIFI7') === 'true' && this.props.buildProduct?.accessPoint?.selectedProduct ? 'Removed - ' + this.props?.ecProfileCart?.ProfileRouterProduct?.prodName : accordionSubTitle : (this.props.name === 'toggle_tv_ceapps_accor' || this.props.name === 'toggle_tv_recording_accor') ? this.checkIfHoaFlow() ? accordionTitle : 'Added - '+accordionTitle : window?.sessionStorage?.getItem('isWIFI7') === 'true' ? accordionTitle : 'Included - '+accordionTitle : (this.props.name === "toggle_tv_channel_accor" ) ? accordionTitle: 'Included - '+accordionTitle) 
                        : this.props.status === AccordionStatus.optional
                          ? 
                          (this.props.isMNEnabled == undefined ? this.subTitleOptTextTV(this.props) :  (!this.props.isMNEnabled && !mm3Qualified ?  this.props.subtitle?.replace('4.0', '')?.replace('4.1', '')?.replaceAll("&reg;", "\u00AE") : 

                            this.subTitleOptTextTV(this.props)
                            
                            
                          ))
                          // commented below line as we are not getting subAccordion subHeading ITT-693813
                          // : this.props.status === "" ? (this.props.name === 'toggle_tv_ceapps_accor' || this.props.name === 'toggle_tv_recording_accor') && 'Added'
                          : this.props.isMNEnabled && this.props.subtitle?.replace('4.0', '')?.replace('4.1', '')?.replaceAll("&reg;", "\u00AE")
                            ? this.props.subtitle?.replace('4.0', '')?.replace('4.1', '')?.replaceAll("&reg;", "\u00AE")
                            : (
                              this.props.name === 'toggle_tv_plan_accor'
                                ? this.subTitleaddText(this.props)
                                : this.props.buildProduct?.isECMNEnabled && !this.props.selectedProduct && this.props.profileCartProduct && (accordionTitleName || this.props.profileCartProduct?.accordionTitle || this.props.profileCartProduct?.name)
                                  ? (accordionTitleName || this.props.profileCartProduct?.accordionTitle || this.props.profileCartProduct?.name)?.replace('4.0', '')?.replace('4.1', '')?.replaceAll("&reg;", "\u00AE")
                                  : ((this.props.buildProduct?.isECMNEnabled && !this.props.selectedProduct && !["Internet","Add TV", "Add Internet", "TV"].includes(accordionTitleName  || this.props.profileCartProduct?.accordionTitle || this.props.profileCartProduct?.name)) && (this.props?.name === 'toggle_internet_accor' || this.props?.name === 'toggle_tv_accor'))
                                    ? <>[{(accordionTitleName || this.props.profileCartProduct?.accordionTitle || this.props.profileCartProduct?.name)?.replace('4.0', '')?.replace('4.1', '')?.replaceAll("&reg;", "\u00AE")}]</>
                                  : this.props?.name === 'toggle_internet_router_accor' && this.props.buildProduct?.accessPoint?.selectedProduct !== null ? 'Removed - ' + this.props?.ecProfileCart?.ProfileRouterProduct?.prodName : ""

                            )
                      }
                      {this.props.status===''&& (this.props.name === 'toggle_tv_recording_accor')?this.subTitleOptText(this.props):''}

                       </AccordionSubTitle>
              }
              {/* {this.checkIfHoaFlow() && this.props?.selectedProduct==null && (this.props?.buildProduct?.productOnProfileStatus?.voice)&& (this.props?.name==="toggle_phone_accor") &&
              <AccordionSubTitle>{this.subTitleOptText(this.props)}</AccordionSubTitle>
              } */}
              <AccordionSubTitle>{(this.props.name == 'toggle_internet_techsure_accor' && this.props.status =="") ? 'Optional' : ''}</AccordionSubTitle>
            <AccordionSubTitle>{(this.props.name == 'toggle_internet_fne_accor' && this.props.status =="") ? 'Optional' : ''}</AccordionSubTitle>
            <AccordionSubTitle>{(this.props.name == 'toggle_phone_plan_accor' && this.props.status =="") ? '' : ''}</AccordionSubTitle>
            <AccordionSubTitle>{(this.props.name == 'toggle_phone_backup_accor' && this.props.status =="") ? 'Optional' : ''}</AccordionSubTitle>
            <AccordionSubTitle>{(this.props.name == 'toggle_internet_perks_accor' && this.props?.selectedProduct?.length == 0) ? <span>Optional - Choose your perks.</span> :  ''}</AccordionSubTitle>           

            {/* <span style ={{fontSize:'1rem', fontWeight:'bold', fontFamily:'Verizon NHG eDS'}}>{this.props?.title === "Perks" && this.props.isAccordionOpen?`Save on every one. Just $${this.props.buildProduct?.perks?.plans?.[0]?.price}/mo each.`:null}</span> */}
            {this.props?.name  === "toggle_tv_settopbox_accor" && this.props.isAccordionOpen ? <div style={{marginTop:'12px',marginBottom:'15px'}}>
            <span style ={{fontSize:'1rem', fontWeight:'normal', fontFamily:'BrandFont-Text, Arial, sans-serif'}}>Select how many TV connections you'd like with Fios.</span>
            </div>:<div style={{display:"none"}}></div>}
              {promoInfo}
            </div>
          </div>
          <div className="inline-block vert-top text-right right call_accordion">
            {this.props.title != "No annual contract" && (
              <div className={headerStatusClass} id="internetstatus">
                {actionStatus}
              </div>
            )}
          </div>
          
        </div>
          </div>
    );

    return <React.Fragment>
      {template}
      <div className = 'saveOnRecommendedMarginBottom'>
      {this.props?.title === "Perks" && this.props.isAccordionOpen? <span className='saveOnRecommended'>Save on every one. Starting at ${this.props.buildProduct?.perks?.plans?.[0]?.price}/mo.</span>:<span style={{display:"none"}}></span>}
      </div>
       </React.Fragment>;
  }
}; 
const mapStateToProps = (state) => {
  return {
    buildProduct: state.buildProduct,
    visitId: state.app.visitId,
    cart: state.cart,
    save: state.save,
    flowType: state.app.flowType,
    moveExp: state.moveExp.moveLandingExp,
    isFCPflow: state.loopQual.isFCPflow,
    isDoFlow: state.loopQual.doFlowDetails.isDoFlow,
    zip: state.loopQual.selectedState ? state.loopQual.selectedState.zip : '',
    tarCode: state.loopQual.selectedState ? state.loopQual.lqResponse.tarcode : '',
    cust_opt: state.moveExp.cust_opt,
    isFcpInProfile: state.loopQual.isFcpInProfile,
    lqState: state.loopQual,
    profileCart: state.profileCart,
    ecProfileCart: state.ecProfileCart
  }
}
export default withCookies(connect(
    mapStateToProps,
)(accordionTitleRskn));
